import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PERMISSION_ROUTE_MAP } from 'src/app/config/permission-route-map';
import { PERMISSION_ROUTE_MAP_TRACER } from 'src/app/config/permission-route-map-tracer';
import { SchoolData } from 'src/app/models/schoolUser';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {

  private permissionsSubject = new BehaviorSubject<string[]>([]);
  permissions$ = this.permissionsSubject.asObservable();

  private isLoaded = false;
  public schoolProps!: SchoolData;

  constructor() {
    this.loadPermissions(); // ✅ always load on init
  }

  loadPermissions() {
    const stored = localStorage.getItem('userData');

    let perms: string[] = [];

    if (stored) {
      const parsed = JSON.parse(stored);
      this.schoolProps = parsed;

      perms = Array.isArray(parsed?.properties?.permissions)
        ? parsed.properties.permissions
        : [];
    }

    // console.log('Loaded permissions:', perms);

    this.permissionsSubject.next(perms);
    this.isLoaded = true;
  }

  refreshPermissions() {
    this.loadPermissions();
  }

  isPermissionsLoaded(): boolean {
    return this.isLoaded;
  }

  getPermissions(): string[] {
    return this.permissionsSubject.getValue();
  }

  hasPermission(permission: string): boolean {
    return this.getPermissions().includes(permission);
  }

  hasAnyPermission(required: string[]): boolean {
    return required.some((p) => this.getPermissions().includes(p));
  }

  getFirstAccessibleRoute(): string | null {

    const perms = this.getPermissions();

    if (this.schoolProps?.properties?.user_type === 'School') {
      const DEFAULT_ROUTE = '/school/school-profile';

      const match = PERMISSION_ROUTE_MAP.find((item) =>
        perms.includes(item.permission)
      );

      return match ? match.route : DEFAULT_ROUTE;
    }

    if (this.schoolProps?.properties?.user_type === 'Tracer') {
      const DEFAULT_ROUTE = '/tracer';

      const match = PERMISSION_ROUTE_MAP_TRACER.find((item) =>
        perms.includes(item.permission)
      );

      return match ? match.route : DEFAULT_ROUTE;
    }

    return '/login';
  }

  getPermissionFromRoute(url: string): string | null {

  let routes: any[] = [];

  if (this.schoolProps?.properties?.user_type === 'School') {
    routes = PERMISSION_ROUTE_MAP;
  }

  if (this.schoolProps?.properties?.user_type === 'Tracer') {
    routes = PERMISSION_ROUTE_MAP_TRACER;
  }

  // 🔥 FIX: sort by longest route first
  const sortedRoutes = routes.sort((a, b) => b.route.length - a.route.length);

  const match = sortedRoutes.find((r) => url.startsWith(r.route));

  // console.log('Matched route:', match);

  return match ? match.permission : null;
}
}